// From: https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_js_dropdown

// Account Dropdown -----------------------------

/* When the user clicks on the button,
toggle between hiding and showing the dropdown content */

function hideOnClickOutside(clickable, target) {
  const outsideClickListener = function(event) {
    const isClickInsideClickable = clickable.contains(event.target);
    const isClickInsideTarget = target.contains(event.target);
    const isTargetVisible = target.offsetParent !== null;

    if (!isClickInsideClickable && !isClickInsideTarget && isTargetVisible) {
      clickable.click();
      removeClickListener();
    }
  }

  const removeClickListener = function() {
    document.removeEventListener('click', outsideClickListener);
  }

  removeClickListener();
  document.addEventListener('click', outsideClickListener);
}

document.addEventListener('click', function(e) {
  const clickable = e.target.closest('[data-toggle="show"], [data-bs-toggle="show"]');
  if (!clickable) return;

  e.preventDefault();
  const target = document.querySelector(clickable.getAttribute('data-target'));
  if (!target) return;

  clickable.classList.toggle('active');
  target.classList.toggle('show');

  // Keep aria-expanded in sync for toggles that advertise one (the masthead menus are now real
  // <button>s with aria-expanded, CU-1248uf3zgd5). Only touch it where it already exists, so nothing
  // else that uses data-toggle="show" is given a role it did not ask for.
  if (clickable.hasAttribute('aria-expanded')) {
    clickable.setAttribute('aria-expanded', String(target.classList.contains('show')));
  }

  if (target.offsetParent !== null) { // Check if element is visible
    hideOnClickOutside(clickable, target);
  }
});
